module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.loading) ? _c('div', [_c('loader')], 1) : _c('div', [_c('h1', [_vm._v("Adicionar Usuários")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "select-items"
    }
  }, [_vm._v("Opções do select")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.csv),
      expression: "csv"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "select-items",
      "rows": "6",
      "placeholder": "Insira os dados dos usuários"
    },
    domProps: {
      "value": (_vm.csv)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.csv = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Resultado - " + _vm._s(_vm.users.length) + " Usuário(s) identificado(s)")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Verifique se os itens foram reconhecidos corretamente.")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-sprited"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.users), function(user) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(user.username))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('td', [_c('ul', {
      staticClass: "list-unstyled"
    }, _vm._l((user.tags), function(tag) {
      return _c('li', [_c('span', {
        staticClass: "label label-primary text-capitalize"
      }, [_vm._v(_vm._s(tag))])])
    }), 0)])])
  }), 0)])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !_vm.users.length
    },
    on: {
      "click": _vm.importUsers
    }
  }, [_vm._v("Importar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Voltar")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Adicione os usuários como linhas, com suas colunas separadas por \";\" (ponto e vírgula) e os dados adicionais separados por \",\" (vírgula) no seguinte formato "), _c('b', [_vm._v("login; nome; email; dados1, dado2, dado3")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Ex: josedasilva@email.com; josedasilva@email.com; José da Silva; Professor, Ciências Naturais, Matemática")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Username")]), _vm._v(" "), _c('th', [_vm._v("E-mail")]), _vm._v(" "), _c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Tags")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13b89d25"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserImport.vue
// module id = 1385
// module chunks = 1